export default __webpack_public_path__ + "static/media/pause.223e5974.svg";